import { Component } from '@angular/core';
import {
  AbstractWorkspaceHostComponent,
  AbstractWorkspaceInputs,
} from '../../shared/abstract-workspace-host.component';
import { LoginWorkspaceComponent } from './login-workspace.component';

export type LoginWorkspaceInputs = AbstractWorkspaceInputs;

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- no loading state with on push
@Component({
  selector: 'h3-login-workspace-host',
  templateUrl: '../../shared/abstract-workspace-host.component.html',
  standalone: false,
})
export class LoginWorkspaceHostComponent
  extends AbstractWorkspaceHostComponent<LoginWorkspaceComponent>
  implements LoginWorkspaceInputs
{
  constructor() {
    super(LoginWorkspaceComponent, []);
  }

  protected override getProjectId() {
    return -1;
  }
}
